/* unplugin-vue-components disabled */import { render } from "./TyttUserAgreement.vue?vue&type=template&id=9ef60a48&scoped=true"
import script from "./TyttUserAgreement.vue?vue&type=script&lang=js"
export * from "./TyttUserAgreement.vue?vue&type=script&lang=js"

import "./TyttUserAgreement.vue?vue&type=style&index=0&id=9ef60a48&lang=scss&scoped=true"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ef60a48"]])

export default __exports__